var parseVersion = (str) => {
	// see webpack/lib/util/semver.js for original code
	var p=p=>{return p.split(".").map(p=>{return+p==p?+p:p})},n=/^([^-+]+)?(?:-([^+]+))?(?:\+(.+))?$/.exec(str),r=n[1]?p(n[1]):[];return n[2]&&(r.length++,r.push.apply(r,p(n[2]))),n[3]&&(r.push([]),r.push.apply(r,p(n[3]))),r;
}
var versionLt = (a, b) => {
	// see webpack/lib/util/semver.js for original code
	a=parseVersion(a),b=parseVersion(b);for(var r=0;;){if(r>=a.length)return r<b.length&&"u"!=(typeof b[r])[0];var e=a[r],n=(typeof e)[0];if(r>=b.length)return"u"==n;var t=b[r],f=(typeof t)[0];if(n!=f)return"o"==n&&"n"==f||("s"==f||"u"==n);if("o"!=n&&"u"!=n&&e!=t)return e<t;r++}
}
var rangeToString = (range) => {
	// see webpack/lib/util/semver.js for original code
	var r=range[0],n="";if(1===range.length)return"*";if(r+.5){n+=0==r?">=":-1==r?"<":1==r?"^":2==r?"~":r>0?"=":"!=";for(var e=1,a=1;a<range.length;a++){e--,n+="u"==(typeof(t=range[a]))[0]?"-":(e>0?".":"")+(e=2,t)}return n}var g=[];for(a=1;a<range.length;a++){var t=range[a];g.push(0===t?"not("+o()+")":1===t?"("+o()+" || "+o()+")":2===t?g.pop()+" "+g.pop():rangeToString(t))}return o();function o(){return g.pop().replace(/^\((.+)\)$/,"$1")}
}
var satisfy = (range, version) => {
	// see webpack/lib/util/semver.js for original code
	if(0 in range){version=parseVersion(version);var e=range[0],r=e<0;r&&(e=-e-1);for(var n=0,i=1,a=!0;;i++,n++){var f,s,g=i<range.length?(typeof range[i])[0]:"";if(n>=version.length||"o"==(s=(typeof(f=version[n]))[0]))return!a||("u"==g?i>e&&!r:""==g!=r);if("u"==s){if(!a||"u"!=g)return!1}else if(a)if(g==s)if(i<=e){if(f!=range[i])return!1}else{if(r?f>range[i]:f<range[i])return!1;f!=range[i]&&(a=!1)}else if("s"!=g&&"n"!=g){if(r||i<=e)return!1;a=!1,i--}else{if(i<=e||s<g!=r)return!1;a=!1}else"s"!=g&&"n"!=g&&(a=!1,i--)}}var t=[],o=t.pop.bind(t);for(n=1;n<range.length;n++){var u=range[n];t.push(1==u?o()|o():2==u?o()&o():u?satisfy(u,version):!o())}return!!o();
}
var exists = (scope, key) => {
	return scope && __webpack_require__.o(scope, key);
}
var get = (entry) => {
	entry.loaded = 1;
	return entry.get()
};
var eagerOnly = (versions) => {
	return Object.keys(versions).reduce((filtered, version) => {
			if (versions[version].eager) {
				filtered[version] = versions[version];
			}
			return filtered;
	}, {});
};
var findLatestVersion = (scope, key, eager) => {
	var versions = eager ? eagerOnly(scope[key]) : scope[key];
	var key = Object.keys(versions).reduce((a, b) => {
		return !a || versionLt(a, b) ? b : a;
	}, 0);
	return key && versions[key];
};
var findSatisfyingVersion = (scope, key, requiredVersion, eager) => {
	var versions = eager ? eagerOnly(scope[key]) : scope[key];
	var key = Object.keys(versions).reduce((a, b) => {
		if (!satisfy(requiredVersion, b)) return a;
		return !a || versionLt(a, b) ? b : a;
	}, 0);
	return key && versions[key]
};
var findSingletonVersionKey = (scope, key, eager) => {
	var versions = eager ? eagerOnly(scope[key]) : scope[key];
	return Object.keys(versions).reduce((a, b) => {
		return !a || (!versions[a].loaded && versionLt(a, b)) ? b : a;
	}, 0);
};
var getInvalidSingletonVersionMessage = (scope, key, version, requiredVersion) => {
	return "Unsatisfied version " + version + " from " + (version && scope[key][version].from) + " of shared singleton module " + key + " (required " + rangeToString(requiredVersion) + ")"
};
var getInvalidVersionMessage = (scope, scopeName, key, requiredVersion, eager) => {
	var versions = scope[key];
	return "No satisfying version (" + rangeToString(requiredVersion) + ")" + (eager ? " for eager consumption" : "") + " of shared module " + key + " found in shared scope " + scopeName + ".\n" +
		"Available versions: " + Object.keys(versions).map((key) => {
		return key + " from " + versions[key].from;
	}).join(", ");
};
var fail = (msg) => {
	throw new Error(msg);
}
var failAsNotExist = (scopeName, key) => {
	return fail("Shared module " + key + " doesn't exist in shared scope " + scopeName);
}
var warn = /*#__PURE__*/ (msg) => {
	if (typeof console !== "undefined" && console.warn) console.warn(msg);
};
var init = (fn) => (function(scopeName, key, eager, c, d) {
	var promise = __webpack_require__.I(scopeName);
	if (promise && promise.then && !eager) {
		return promise.then(fn.bind(fn, scopeName, __webpack_require__.S[scopeName], key, false, c, d));
	}
	return fn(scopeName, __webpack_require__.S[scopeName], key, eager, c, d);
});

var useFallback = (scopeName, key, fallback) => {
	return fallback ? fallback() : failAsNotExist(scopeName, key);
}
var load = /*#__PURE__*/ init((scopeName, scope, key, eager, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	return get(findLatestVersion(scope, key, eager));
});
var loadVersion = /*#__PURE__*/ init((scopeName, scope, key, eager, requiredVersion, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	var satisfyingVersion = findSatisfyingVersion(scope, key, requiredVersion, eager);
	if (satisfyingVersion) return get(satisfyingVersion);
	warn(getInvalidVersionMessage(scope, scopeName, key, requiredVersion, eager))
	return get(findLatestVersion(scope, key, eager));
});
var loadStrictVersion = /*#__PURE__*/ init((scopeName, scope, key, eager, requiredVersion, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	var satisfyingVersion = findSatisfyingVersion(scope, key, requiredVersion, eager);
	if (satisfyingVersion) return get(satisfyingVersion);
	if (fallback) return fallback();
	fail(getInvalidVersionMessage(scope, scopeName, key, requiredVersion, eager));
});
var loadSingleton = /*#__PURE__*/ init((scopeName, scope, key, eager, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	var version = findSingletonVersionKey(scope, key, eager);
	return get(scope[key][version]);
});
var loadSingletonVersion = /*#__PURE__*/ init((scopeName, scope, key, eager, requiredVersion, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	var version = findSingletonVersionKey(scope, key, eager);
	if (!satisfy(requiredVersion, version)) {
		warn(getInvalidSingletonVersionMessage(scope, key, version, requiredVersion));
	}
	return get(scope[key][version]);
});
var loadStrictSingletonVersion = /*#__PURE__*/ init((scopeName, scope, key, eager, requiredVersion, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	var version = findSingletonVersionKey(scope, key, eager);
	if (!satisfy(requiredVersion, version)) {
		fail(getInvalidSingletonVersionMessage(scope, key, version, requiredVersion));
	}
	return get(scope[key][version]);
});
var installedModules = {};
var moduleToHandlerMapping = {
	3326: () => (loadSingletonVersion("default", "react", false, [4,19,2,4], () => (__webpack_require__.e(162).then(() => (() => (__webpack_require__(162))))))),
	8759: () => (loadSingletonVersion("default", "react-dom", false, [4,19,2,4], () => (__webpack_require__.e(85).then(() => (() => (__webpack_require__(5466))))))),
	4668: () => (loadSingletonVersion("default", "react/jsx-runtime", false, [1,19,2,0], () => (__webpack_require__.e(349).then(() => (() => (__webpack_require__(6730))))))),
	6284: () => (loadSingletonVersion("default", "@emotion/react", false, [4,11,14,0], () => (Promise.all([__webpack_require__.e(311), __webpack_require__.e(167)]).then(() => (() => (__webpack_require__(9548))))))),
	4134: () => (loadSingletonVersion("default", "@vision/auth-core", false, [4,1,6,0], () => (Promise.all([__webpack_require__.e(876), __webpack_require__.e(367)]).then(() => (() => (__webpack_require__(9876))))))),
	4823: () => (loadSingletonVersion("default", "react-router-dom", false, [4,7,13,1], () => (Promise.all([__webpack_require__.e(246), __webpack_require__.e(759)]).then(() => (() => (__webpack_require__(2246))))))),
	5647: () => (loadSingletonVersion("default", "@vision/api-client", false, [4,1,7,0], () => (Promise.all([__webpack_require__.e(668), __webpack_require__.e(33), __webpack_require__.e(632)]).then(() => (() => (__webpack_require__(6251))))))),
	9319: () => (loadSingletonVersion("default", "@vision/store", false, [4,1,3,1], () => (Promise.all([__webpack_require__.e(525), __webpack_require__.e(740)]).then(() => (() => (__webpack_require__(1740))))))),
	3233: () => (loadSingletonVersion("default", "@emotion/styled", false, [4,11,14,0], () => (__webpack_require__.e(733).then(() => (() => (__webpack_require__(4114))))))),
	4165: () => (loadSingletonVersion("default", "react/jsx-runtime", false, [,[1,19,0,0],[1,18,0,0],[1,17,0,0],1,1], () => (__webpack_require__.e(349).then(() => (() => (__webpack_require__(6730))))))),
	8525: () => (loadSingletonVersion("default", "react-redux", false, [4,9,2,0], () => (Promise.all([__webpack_require__.e(978), __webpack_require__.e(326)]).then(() => (() => (__webpack_require__(597))))))),
	1197: () => (loadSingletonVersion("default", "react-hook-form", false, [1,7,74,0], () => (__webpack_require__.e(100).then(() => (() => (__webpack_require__(4100))))))),
	1940: () => (loadSingletonVersion("default", "@vision/security", false, [4,2,5,4], () => (Promise.all([__webpack_require__.e(410), __webpack_require__.e(367)]).then(() => (() => (__webpack_require__(6410))))))),
	1946: () => (loadSingletonVersion("default", "react/jsx-runtime", false, [,[1,19],[1,18],[1,17],[1,16,8],1,1,1], () => (__webpack_require__.e(349).then(() => (() => (__webpack_require__(6730))))))),
	6221: () => (loadSingletonVersion("default", "react/jsx-runtime", false, [4,19,2,4], () => (__webpack_require__.e(349).then(() => (() => (__webpack_require__(6730))))))),
	7773: () => (loadSingletonVersion("default", "@mui/material", false, [1,9,2,0], () => (Promise.all([__webpack_require__.e(311), __webpack_require__.e(237)]).then(() => (() => (__webpack_require__(6237))))))),
	8260: () => (loadSingletonVersion("default", "react-dom/client", false, [4,19,2,4], () => (__webpack_require__.e(739).then(() => (() => (__webpack_require__(2739))))))),
	6049: () => (loadSingletonVersion("default", "react/jsx-runtime", false, [,[1,19],[1,18],1], () => (__webpack_require__.e(349).then(() => (() => (__webpack_require__(6730))))))),
	4033: () => (loadSingletonVersion("default", "@tanstack/react-query", false, [1,5,97,0], () => (Promise.all([__webpack_require__.e(935), __webpack_require__.e(49)]).then(() => (() => (__webpack_require__(4935))))))),
	9367: () => (loadSingletonVersion("default", "react/jsx-runtime", false, [0,19], () => (__webpack_require__.e(349).then(() => (() => (__webpack_require__(6730))))))),
	3266: () => (loadSingletonVersion("default", "@reduxjs/toolkit", false, [4,2,8,2], () => (__webpack_require__.e(151).then(() => (() => (__webpack_require__(6151)))))))
};
// no consumes in initial chunks
var chunkMapping = {
	"33": [
		4033
	],
	"49": [
		6049
	],
	"107": [
		1197,
		1940,
		1946,
		6221,
		7773,
		8260
	],
	"197": [
		3233,
		4165
	],
	"284": [
		6284
	],
	"326": [
		3326
	],
	"367": [
		9367
	],
	"460": [
		4134,
		4823,
		5647,
		9319
	],
	"525": [
		8525
	],
	"668": [
		4668
	],
	"740": [
		3266
	],
	"759": [
		8759
	]
};
var startedInstallModules = {};
__webpack_require__.f.consumes = (chunkId, promises) => {
	if(__webpack_require__.o(chunkMapping, chunkId)) {
		chunkMapping[chunkId].forEach((id) => {
			if(__webpack_require__.o(installedModules, id)) return promises.push(installedModules[id]);
			if(!startedInstallModules[id]) {
			var onFactory = (factory) => {
				installedModules[id] = 0;
				__webpack_require__.m[id] = (module) => {
					delete __webpack_require__.c[id];
					module.exports = factory();
				}
			};
			startedInstallModules[id] = true;
			var onError = (error) => {
				delete installedModules[id];
				__webpack_require__.m[id] = (module) => {
					delete __webpack_require__.c[id];
					throw error;
				}
			};
			try {
				var promise = moduleToHandlerMapping[id]();
				if(promise.then) {
					promises.push(installedModules[id] = promise.then(onFactory)['catch'](onError));
				} else onFactory(promise);
			} catch(e) { onError(e); }
			}
		});
	}
}